import React, {useCallback, useContext} from 'react';
import {EditorContext, useEditorState} from "@tiptap/react";
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import HeadingIcon from "./icons/heading-icon.jsx";
import HeadingOneIcon from "./icons/heading-one-icon.jsx";
import HeadingTwoIcon from "./icons/heading-two-icon.jsx";
import HeadingThreeIcon from "./icons/heading-three-icon.jsx";
import HeadingFourIcon from "./icons/heading-four-icon.jsx";
import HeadingFiveIcon from "./icons/heading-five-icon.jsx";
import HeadingSixIcon from "./icons/heading-six-icon.jsx";
import {FaChevronDown} from "react-icons/fa";

const headingIcons = {
    1: HeadingOneIcon,
    2: HeadingTwoIcon,
    3: HeadingThreeIcon,
    4: HeadingFourIcon,
    5: HeadingFiveIcon,
    6: HeadingSixIcon,
}

const HeadingButton = ({editor, level}) => {
    const Icon = headingIcons[level];

    const isActive = useEditorState({
        editor,
        selector: ({ editor }) => !!editor?.isActive("heading", { level }),
    });

    function toggleHeading(editor, level) {
        if (!editor) return

        if (editor.isActive("heading", { level })) {
            editor.chain().focus().setNode("paragraph").run()
        } else {
            editor.chain().focus().toggleNode("heading", "paragraph", { level }).run()
        }
    }

    const handleClick = useCallback(
        (e) => {

            if (!e.defaultPrevented && editor) {
                toggleHeading(editor, level)
            }
        },
        [editor, level]
    )

    return (
        <MenuItem>
            <button className={"rich-text-button" + (isActive ? " active" : "")} onClick={handleClick}>
                <Icon className="rich-text-button-icon" /> Título {level}
            </button>
        </MenuItem>
    )
}

const RichTextHeadingDropdownMenu = ({levels}) => {
    const { editor } = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null;

    const activeLevel = useEditorState({
        editor,
        selector: ({ editor }) => {
            if (!editor) return null;
            return levels.find((l) => editor.isActive("heading", { level: l })) ?? null;
        },
    });

    const ActiveIcon = activeLevel ? headingIcons[activeLevel] : HeadingIcon;

    return (
        <Menu>
            <MenuButton className="rich-text-button">
                <ActiveIcon className="rich-text-button-icon" />
                <FaChevronDown className="rich-text-button-dropdown-small" />
            </MenuButton>
            <Transition
                enter="transition ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <MenuItems anchor="bottom" className="heading-dropdown">
                    {
                        levels.map(l => <HeadingButton editor={editor} level={l} key={l}/>)
                    }
                </MenuItems>
            </Transition>
        </Menu>
    );
};

export default RichTextHeadingDropdownMenu;